"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SchedulerError {
    constructor(code, message) {
        this._code = code;
        this._message = message;
    }
    get code() {
        return this._code;
    }
    get message() {
        return this._message;
    }
}
exports.default = SchedulerError;
